import React from 'react'

import ImageListItem from '../../views/listview/ImageListItem'
import config from '../../../config'
import { LevelLeft, LevelItem, LevelRight } from '../../views/layouts/Level'

export const withImageListItem = (Component, ButtonItems) =>
  class ImageListItemWrapper extends React.Component {
    state = {
      imageURLTrailing: undefined,
    }

    handleReloadImage = () => {
      this.setState({
        imageURLTrailing: new Date().getTime(),
      })
    }

    imageURL = () => {
      let imageURL
      if (this.props.item && this.props.item.mainImageId)
        imageURL = `${config.imageURLPrefix}/${this.props.item.mainImageId}`

      if (this.state.imageURLTrailing) {
        imageURL = imageURL + `?${this.state.imageURLTrailing}`
      }
      return imageURL
    }


    imageAlt = () => {
      if (this.props.item && this.props.item.title)
        return this.props.item.title.th
      return undefined
    }

    render() {
      const { item, itemIndex } = this.props
      return (
        <ImageListItem
          imageURL={this.imageURL()}
          imageAlt={this.imageAlt()}
          toolbar={
            <ImageItemToolbar
              item={item}
              itemIndex={itemIndex}
              onReloadImage={this.handleReloadImage}
              ButtonItems={ButtonItems}
            />
          }
          getImageRef={this.getImageRef}
        >
          <Component {...this.props} onReloadImage={this.handleReloadImage} />
        </ImageListItem>
      )
    }
  }

const ImageItemToolbar = ({ item, itemIndex, onReloadImage, ButtonItems }) => (
  <React.Fragment>
    <LevelLeft />
    <LevelRight>
      {ButtonItems &&
        ButtonItems.map((Item, index) => (
          <LevelItem key={index}>
            <Item
              item={item}
              itemIndex={itemIndex}
              onReloadImage={onReloadImage}
            />
          </LevelItem>
        ))}
    </LevelRight>
  </React.Fragment>
)



// WEBPACK FOOTER //
// ./src/components/templates/image-edit/ImageItem.js